import { z } from 'zod';

export const CatalogPriceResponseSchema = z.object({
  currency: z.string(),
  majorValue: z.string(),
});
